/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { AssetType, IMediaModel, TimeHelper } from "@bms/common";
import { useTranslation } from "react-i18next";

import { If } from "components/If";

import "./MatchScoreInfo.scss";

type MatchScoreInfoProps = {
  media: IMediaModel;
};

export const MatchScoreInfo = ({ media }: MatchScoreInfoProps) => {
  const { t } = useTranslation();

  const currentTime = TimeHelper.getCurrentDateTime();
  const startTime = media?.StartDateTime
    ? TimeHelper.getDateTime(media.StartDateTime)
    : null;
  const endTime = media?.EndDateTime
    ? TimeHelper.getDateTime(media.EndDateTime)
    : null;
  const isOngoing = startTime && startTime <= currentTime;
  const isEnded = endTime && endTime <= currentTime;

  const scoreString =
    isEnded || isOngoing
      ? `${media?.Match?.HomeTeamScore} - ${media?.Match?.AwayTeamScore}`
      : "-";

  if (media.MediaTypeCode !== AssetType.Match) {
    return null;
  }

  return (
    <div className="MatchScoreInfo">
      <div className="MatchScoreInfo__score">{scoreString}</div>
      <If condition={isEnded}>
        <div className="MatchScoreInfo__finish_info">{t("MATCH_FINISHED")}</div>
      </If>
    </div>
  );
};
